import React, { useEffect } from "react";
import { Form, Select, Typography } from "antd";

import { elvis } from "../../Utils";

const { Option } = Select;
const { Title } = Typography;

// Mirrors the server enum it.polimi.lode.model.building.ArtisticGoodKind.
// Labels are English; i18n later.
const ARTISTIC_GOOD_KINDS = [
    { value: "FRESCO",              label: "Fresco" },
    { value: "MOVABLE_PAINTING",    label: "Movable painting" },
    { value: "MOSAIC",              label: "Mosaic" },
    { value: "FURNITURE",           label: "Furniture" },
    { value: "STUCCO",              label: "Stucco" },
    { value: "PLASTIC_DECORATION",  label: "Plastic decoration" },
    { value: "TAPESTRY",            label: "Tapestry" },
    { value: "PAPER_PARCHMENT",     label: "Paper / parchment" },
    { value: "ALTAR_STATUE",        label: "Altar or statue" },
    { value: "ARCHAEOLOGICAL_FIND", label: "Archaeological find" },
    { value: "BOOK_PRINT",          label: "Book or print" },
    { value: "OTHER",               label: "Other" },
];

const ArtisticGoodForm = props => {
    const [form] = Form.useForm();
    const isEditMode = props.isEditMode || false;

    const formItemLayout = {
        labelCol: { sm: { span: 8 } },
        wrapperCol: { sm: { span: 16 } },
    };

    useEffect(() => {
        if (props.record.asset) {
            form.setFieldsValue({
                kind: props.record.asset.kind,
            });
        }
    }, [props.record.asset, form]);

    useEffect(() => {
        if (!isEditMode && props.record.asset) {
            form.resetFields();
            form.setFieldsValue({
                kind: props.record.asset.kind,
            });
        }
    }, [isEditMode, form, props.record.asset]);

    const handleFormChange = () => {
        if (!isEditMode) return;

        const values = form.getFieldsValue();
        const errors = form.getFieldsError();
        const isValid = errors.every(error => !error.errors.length);

        const newAsset = { ...props.record };
        newAsset.asset.kind = elvis(values.kind);
        newAsset.valid = isValid;

        props.parentCallback(newAsset);
    };

    return (
        <Form
            form={form}
            {...formItemLayout}
            className="details_form"
            onValuesChange={handleFormChange}
            onFieldsChange={handleFormChange}
        >
            <Title level={4}>Artistic good</Title>
            <Form.Item label="Kind" name="kind">
                <Select disabled={!isEditMode} allowClear>
                    {ARTISTIC_GOOD_KINDS.map(opt => (
                        <Option key={opt.value} value={opt.value}>{opt.label}</Option>
                    ))}
                </Select>
            </Form.Item>
        </Form>
    );
};

export default ArtisticGoodForm;
